<div class="config-panel">
  <h2 class="headline mb-4">
    <mat-icon class="mr-3" svgIcon="mat:settings"></mat-icon>
    <span>Configuration</span>
  </h2>

  <div class="section">
    <h5 class="subheading">THEME BASE</h5>

    <div (click)="isDark(colorScheme) ? disableDarkMode() : enableDarkMode()"
      *ngIf="colorScheme$ | async as colorScheme"
      class="rounded-full mt-2 flex items-center cursor-pointer relative bg-black text-white select-none" matRipple>
      <div class="m-2 h-6 w-6 rounded-full">
        <mat-icon *ngIf="isDark(colorScheme)" svgIcon="mat:check"></mat-icon>
        <mat-icon *ngIf="!isDark(colorScheme)" svgIcon="mat:close"></mat-icon>
      </div>
      <p class="ml-1 font-medium text-sm">DARK MODE</p>
    </div>
  </div>

  <div class="section">
    <h5 class="subheading">THEME COLORS</h5>

    <div (click)="selectTheme(theme)" *ngFor="let theme of themes" [ngClass]="{
        'bg-primary-600/10 dark:bg-primary-500/20 text-primary-600 dark:text-primary-500':
          !(isSelectedTheme$ | async)?.(theme.className),
        'bg-primary-600 text-on-primary-600': (isSelectedTheme$ | async)?.(
          theme.className
        )
      }"
      class="{{
        theme.className
      }} vex-color-picker rounded-full mt-2 flex items-center cursor-pointer relative hover:bg-primary-600 hover:text-on-primary-600 dark:hover:bg-primary-600 dark:hover:text-on-primary-600"
      matRipple>
      <div class="m-2 h-6 w-6 rounded-full text-on-primary-600 bg-primary-600">
        <mat-icon *ngIf="(isSelectedTheme$ | async)?.(theme.className)" svgIcon="mat:check"></mat-icon>
      </div>
      <p class="ml-1 font-medium text-sm">{{ theme.name | uppercase }}</p>
    </div>
  </div>

  <div class="section">
    <h5 class="subheading">SECONDARY COLORS</h5>

    <div (click)="selectAccent(accent)" *ngFor="let accent of accents" [ngClass]="{
        'bg-accent-600/10 text-accent-ink':
          !(isSelectedAccent$ | async)?.(accent.className),
        'bg-accent-600 text-on-accent-600': (isSelectedAccent$ | async)?.(
          accent.className
        )
      }"
      class="{{
        accent.className
      }} vex-color-picker rounded-full mt-2 flex items-center cursor-pointer relative hover:bg-accent-600 hover:text-on-accent-600"
      matRipple>
      <div class="m-2 h-6 w-6 rounded-full text-on-accent-600 bg-accent-600">
        <mat-icon *ngIf="(isSelectedAccent$ | async)?.(accent.className)" svgIcon="mat:check"></mat-icon>
      </div>
      <p class="ml-1 font-medium text-sm">{{ accent.name | uppercase }}</p>
    </div>
  </div>

  <div class="section">
    <h5 class="subheading">Layout</h5>

    <div class="section-content">
      <h5 class="subheading">Orientation</h5>

      <mat-slide-toggle (change)="layoutRTLChange($event)" [checked]="isRTL$ | async">RTL
        <span
          class="ms-2 align-middle rounded-full bg-accent-500 px-2 py-0.5 text-[10px] font-medium uppercase leading-none tracking-wide text-white">
          Beta
        </span>
      </mat-slide-toggle>
    </div>
  </div>
</div>